import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import { updateCompany } from '@actions/currentUser'
import { selectCurrentUserCompanyId } from '@reducers/currentUser/currentUserSelectors'

const MakeDefaultPaymentMethodButton = (props) => {
  const { paymentMethodId } = props
  const companyId = useSelector(selectCurrentUserCompanyId)

  const [isMakeDefaultLoading, setIsMakeDefaultLoading] = useState(false)

  const dispatch = useDispatch()

  const onMakeDefault = async () => {
    setIsMakeDefaultLoading(true)

    await dispatch(
      updateCompany(
        { default_payment: paymentMethodId },
        companyId,
      ),
    )

    setIsMakeDefaultLoading(false)
  }

  return (
    <Button
      size="small"
      onClick={onMakeDefault}
      loading={isMakeDefaultLoading}
    >
      Make Default
    </Button>
  )
}

export default MakeDefaultPaymentMethodButton
